// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionReason-cls1_dy6","cls2":"SuggestionReason-cls2_QMG SuggestionReason-cls1_dy6"};